// extracted by mini-css-extract-plugin
export default {"starButton":"SpacesSelectionMenu-module__starButton--EpO1d"};